import * as ActionType from "./transaction.type";

const initialState = {
  transactions: [],
  liveFeed: [],
  stats: null,
  pagination: {
    total: 0,
    page: 1,
    limit: 20,
    totalPages: 0,
  },
};

export const transactionReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.GET_TRANSACTIONS:
      return {
        ...state,
        transactions: action.payload.transactions,
        pagination: action.payload.pagination,
      };

    case ActionType.GET_LIVE_FEED:
      // Only update if data actually changed (compare by first item's _id)
      const newFirstId = action.payload?.[0]?._id;
      const oldFirstId = state.liveFeed?.[0]?._id;
      const newLastId = action.payload?.[action.payload?.length - 1]?._id;
      const oldLastId = state.liveFeed?.[state.liveFeed?.length - 1]?._id;

      // If same data, don't update state to prevent re-render
      if (newFirstId === oldFirstId && newLastId === oldLastId && action.payload?.length === state.liveFeed?.length) {
        return state;
      }

      return {
        ...state,
        liveFeed: action.payload,
      };

    case ActionType.GET_TRANSACTION_STATS:
      return {
        ...state,
        stats: action.payload,
      };

    case ActionType.NEW_TRANSACTION:
      // Add new transaction to the top of live feed (max 20)
      const newLiveFeed = [action.payload, ...state.liveFeed].slice(0, 20);
      return {
        ...state,
        liveFeed: newLiveFeed,
      };

    default:
      return state;
  }
};
